import React, { Component } from 'react';
import DropZone from 'react-dropzone';
import ReactTooltip from 'react-tooltip';

class FileView extends Component {
  constructor( props ) {
    super( props );

    this.onFileClick = this.onFileClick.bind( this );
  }

  /**
   * The click event on the filename. Calls the parent's event to remove the
   * file from the DropZone.
   *
   * @param {Event} event The click event.
   */
  onFileClick( event ) {
    this.props.onClickRemove( event, this.props.filename );

    event.stopPropagation();
  }

  render() {
    return (
      <div className='upload-dropzone-filename-container'>
        <span className='upload-dropzone-filename' data-tip data-for='delete-file' onClick={this.onFileClick}>{this.props.filename}</span>
        <ReactTooltip id='delete-file'><span>Click to remove the file</span></ReactTooltip>
      </div>
    );
  }
}

class UploadDropZone extends Component {
  constructor( props ) {
    super( props );

    this.onDrop = this.onDrop.bind( this );
  }

  /**
   * Adds files to the fileview/DropZone.
   *
   * @param {Array<File>} files Files that are added into the DropZone.
   */
  onDrop( files ) {
    let currentFiles = [...this.props.acceptedFiles];

    for ( let i = 0; i < files.length; ++i ) {
      const file = files[i];  // New incoming file
      let valid = true;       // Flag determining if file already exists

      for ( let j = 0; j < currentFiles.length && valid; ++j ) {
        const currentFile = currentFiles[j];

        if ( file.name === currentFile.name ) {
          valid = false;
        }
      }

      if ( valid ) {
        currentFiles.push( file );
      }
    }

    // Notify parent of the updated files
    this.props.onAddFile( currentFiles );
  }

  render() {
    const fileView = this.props.acceptedFiles.map( ( file ) => {
      return <FileView key={file.name} filename={file.name} onClickRemove={this.props.onClickRemove} />
    } );

    return (
      <DropZone
        className='file-management-file-upload-dropzone'
        onDrop={this.onDrop}
        style={{
          width: '100%',
          height: '100%',
          border: 'solid thin #c8c8c8',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          overflow: 'auto'
        }}
      >
        {
          fileView.length > 0
            ? fileView
            : <div>Drop files to attach or click to browse</div>
        }
      </DropZone>
    );
  }
}

export default UploadDropZone;


// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/UploadDropZone.js